(function metadataDetailControllerDefinition() {
    'use strict';

    angular.module('Metadata')
        .controller('MetadataDetailController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', '$stateParams', 'adminMetadataService', 'authExtend',
            function metadataDetailController($scope, config, $state, $translate, errors, $stateParams, adminMetadataService, authExtend) {
                $translate(['MetadataDetail']).then(function (translated) {
                    $scope.title = translated.MetadataDetail;
                });

                adminMetadataService.getById($stateParams.id).then(function (result) {
                    $scope.metadata = result;
                    if ($scope.metadata.attributes) {
                        for (var i = 0; $scope.metadata.attributes.length > i; i++) {
                            if ($scope.metadata.attributes[i].type === 'optionsValues') {
                                $scope.isOptionType = true;
                                $scope.metadata.attributes[i].values = $.parseJSON($scope.metadata.attributes[i].value);
                                if (!$scope.metadata.attributes[i].values || $scope.metadata.attributes[i].values === '') {
                                    $scope.metadata.attributes[i].values = [];
                                }
                            }
                        }
                    }

                    if ($scope.typeDatas) {
                        $scope.typeDatas.forEach(function (data) {
                            if (data.id === $scope.metadata.typeDataId) {
                                $scope.aux.typeData = data;
                            }
                        });
                    }

                }, function (error) {
                    errors.showError(error);
                    $state.go('metadata-find');
                });

                $scope.cancel = function () {
                    $state.goBack("metadata-find");
                };
            }
        ]);
})();